import { useMutation } from "@apollo/client";
import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { SYNC_PROJECT_SELLIGENT } from "utils/api/graphql/mutations/projects";
import { CONTACT_POINT_SYSTEM, SELLIGENT_STEPS } from "utils/constants";
import View from "./View";

const AdherentTelecoms = ({ project, onNext, onBack, setDisplayProject }) => {
  const [syncProjectWithSelligent] = useMutation(SYNC_PROJECT_SELLIGENT, {
    variables: {
      project: { id: project.id },
      step: SELLIGENT_STEPS.PROSPECTION,
    },
    onCompleted: ({ syncProjectWithSelligent }) =>
      setDisplayProject((prev) => ({
        ...prev,
        externalId: get(syncProjectWithSelligent, "externalId"),
      })),
    onError: (error) => console.log(error),
  });
  const telecoms = defaults(keyBy(get(project, "contact.telecoms"), "system"), {
    [CONTACT_POINT_SYSTEM.PHONE]: { value: null },
    [CONTACT_POINT_SYSTEM.EMAIL]: { value: null },
  });
  const next = ({ telecoms, ...contact }) => {
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    onNext({
      payload: {
        contact: {
          ...contact,
          acceptContactDate:
            get(project, "contact.acceptContactDate") || new Date(),
          id: get(project, "contact.id") || cuid(),
          telecoms: updatedTelecoms,
          user: {
            id: cuid(),
            ...contact.user,
          },
        },
        visible: true,
      },
      onCompleted: () => !project.externalId && syncProjectWithSelligent(),
    });
  };
  return (
    <View
      onNext={next}
      contact={{ ...get(project, "contact", {}), telecoms }}
      fields={get(project, "fields")}
      locked={project.locked}
      onBack={onBack}
    />
  );
};

export default AdherentTelecoms;
